var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _g2, _path8, _path9, _path0, _g3, _path1, _path10, _g4, _path11, _g5, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _rect, _path31, _path32, _path33, _path34, _g6, _path35, _path36, _path37, _path38, _path39, _path40, _g7, _path41, _path42, _path43, _path44, _path45, _path46, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShield = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 300,
    fill: "none",
    viewBox: "0 0 300 300",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#shield_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C1C",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.465,
    d: "M263.465 82.742c.102 0 .193.065.224.162l5.63 17.836q.021.066.002.134c-7.481 25.8-19.603 49.89-35.969 71.245-14.903 19.445-32.634 35.888-48.912 48.121-16.403 12.326-31.513 20.748-42.553 26.087-6.705 3.243-13.501 6.207-20.603 8.384a.23.23 0 0 1-.213-.041c-8.89-7.089-15.032-16.533-22.014-25.32a.233.233 0 0 1 .037-.327l.49-.391a.236.236 0 0 1 .327.037l.102.129c3.115 3.914 6.488 7.587 10.368 10.712l1.943-.604.001-.001.015-.005h.001c.495-.165 7.549-2.506 18.694-7.916 11.351-5.51 26.966-14.206 43.931-26.868 16.83-12.559 34.736-28.825 50.633-49.193 17.072-21.869 29.64-45.516 37.645-72.015l.032-.067a.23.23 0 0 1 .189-.099Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1C1C1C",
    strokeLinejoin: "round",
    strokeWidth: 0.465,
    d: "m110.265 240.16 10.936 14.176"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C1C",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.465,
    d: "M181.468 56.243c1.842-.01 3.575.159 5.254.475s3.33.795 4.982 1.398 3.334 1.337 5.094 2.165q1.318.624 2.716 1.322l2.894 1.459a215 215 0 0 0 9.141 4.4 193 193 0 0 0 12.317 5.053 218 218 0 0 0 16.051 5.231c6.079 1.728 12.856 3.39 20.389 4.892l3.237.642a.233.233 0 0 1 .177.296l-.843 2.783c-7.987 26.346-21.178 49.514-36.665 69.313-15.947 20.377-33.906 36.648-50.781 49.207-17.011 12.656-32.643 21.349-44.057 26.872-11.412 5.522-18.522 7.844-18.808 7.939l-.004.001-2.227.693a.23.23 0 0 1-.214-.041l-1.48-1.183-.274-.229c-1.088-.933-5.226-4.655-10.273-11.247-5.612-7.34-12.23-18.08-16.882-32.193s-7.039-29.943-5.269-49.28c1.679-18.374 7.286-39.279 18.922-62.854l1.195-2.416a.23.23 0 0 1 .17-.126l2.854-.475a215 215 0 0 0 18.398-3.893 206 206 0 0 0 15.105-4.535c4.551-1.555 8.687-3.131 12.517-4.628 3.829-1.496 7.374-2.924 10.77-4.19l3.827-1.415q1.852-.681 3.591-1.3a130 130 0 0 1 6.578-2.16c2.077-.612 4.063-1.095 5.976-1.432 1.912-.337 3.78-.533 5.622-.544Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7F3FF",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.465,
    d: "M180.711 55.437c1.859-.011 3.608.159 5.302.476 1.694.318 3.359.8 5.027 1.405 1.667.606 3.365 1.342 5.142 2.174 1.776.832 3.644 1.779 5.661 2.793h.001a217 217 0 0 0 9.224 4.42c3.563 1.599 7.725 3.34 12.432 5.074a221 221 0 0 0 16.198 5.254c6.136 1.736 12.975 3.406 20.577 4.913l3.268.647a.233.233 0 0 1 .178.296l-.852 2.795c-8.06 26.461-21.372 49.73-37.003 69.616-16.094 20.467-34.219 36.808-51.25 49.422-17.167 12.712-32.943 21.442-44.463 26.989s-18.696 7.88-18.981 7.975l-.004.002-2.247.694a.23.23 0 0 1-.214-.04l-1.495-1.189v-.001c-.215-.17-4.832-3.972-10.643-11.525-5.663-7.372-12.342-18.159-17.037-32.333-4.695-14.175-7.105-30.074-5.318-49.496 1.694-18.455 7.354-39.451 19.097-63.13l1.206-2.426.03-.046a.23.23 0 0 1 .14-.08l2.88-.477a218 218 0 0 0 18.568-3.91 209 209 0 0 0 15.245-4.554c4.593-1.562 8.767-3.146 12.633-4.649 3.864-1.502 7.441-2.938 10.869-4.209l3.863-1.422q1.868-.683 3.623-1.303a132 132 0 0 1 6.639-2.17c2.095-.615 4.101-1.1 6.031-1.439s3.814-.535 5.673-.546Z"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    width: 189.155,
    height: 181.328,
    x: 74.031,
    y: 55.611
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(.93px)",
      clipPath: "url(#shield_svg__b)",
      height: "100%",
      width: "100%"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.465,
    d: "M180.316 57.705c1.809-.01 3.511.152 5.16.456 1.648.304 3.269.765 4.891 1.346 1.622.58 3.274 1.285 5.002 2.082s3.547 1.703 5.509 2.675l1.984.978a202 202 0 0 0 6.991 3.254 192 192 0 0 0 12.094 4.86c4.58 1.66 9.87 3.39 15.759 5.03 5.969 1.662 12.623 3.262 20.02 4.706l3.178.619a.23.23 0 0 1 .156.108.24.24 0 0 1 .022.189l-.827 2.677h-.001c-7.842 25.342-20.795 47.626-36.002 66.669-15.659 19.601-33.293 35.251-49.862 47.331-16.703 12.173-32.052 20.534-43.259 25.846-11.205 5.312-18.187 7.545-18.467 7.637l-.005.001-2.186.665a.23.23 0 0 1-.211-.039l-1.453-1.138-.269-.22c-1.068-.898-5.132-4.479-10.088-10.82-5.51-7.06-12.009-17.391-16.577-30.967-4.568-13.575-6.913-28.802-5.175-47.403 1.648-17.675 7.156-37.784 18.581-60.46l1.173-2.323.03-.046a.23.23 0 0 1 .14-.08l2.802-.456a215 215 0 0 0 18.064-3.744 206 206 0 0 0 14.831-4.362c4.469-1.495 8.53-3.011 12.291-4.45 3.759-1.44 7.24-2.814 10.575-4.031l3.758-1.361q1.818-.656 3.526-1.25c2.279-.79 4.421-1.489 6.459-2.078 2.039-.589 3.989-1.053 5.867-1.378s3.711-.512 5.519-.523Z",
    "data-figma-bg-blur-radius": 1.861
  })), /*#__PURE__*/React.createElement("mask", {
    id: "shield_svg__d",
    width: 185,
    height: 178,
    x: 76,
    y: 57,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, /*#__PURE__*/React.createElement("foreignObject", {
    width: 189.155,
    height: 181.328,
    x: 74.031,
    y: 55.611
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(.93px)",
      clipPath: "url(#shield_svg__c)",
      height: "100%",
      width: "100%"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    d: "M180.318 57.938c1.794-.01 3.481.15 5.116.452s3.242.76 4.855 1.336 3.258 1.279 4.983 2.074c1.724.796 3.539 1.7 5.503 2.672a213 213 0 0 0 8.983 4.237 192 192 0 0 0 12.11 4.865 218 218 0 0 0 15.776 5.037c5.975 1.663 12.635 3.264 20.037 4.71l3.179.618-.828 2.677c-7.832 25.31-20.769 47.568-35.962 66.593-15.643 19.581-33.261 35.217-49.817 47.287-16.689 12.164-32.025 20.517-43.222 25.825-11.196 5.307-18.169 7.537-18.44 7.625l-2.186.666-1.454-1.139c-.18-.14-4.664-3.768-10.316-10.999-5.497-7.043-11.982-17.351-16.54-30.898-4.558-13.546-6.898-28.74-5.163-47.308 1.645-17.642 7.142-37.722 18.557-60.376l1.172-2.323 2.802-.458a216 216 0 0 0 18.085-3.748 206 206 0 0 0 14.847-4.366c4.474-1.497 8.538-3.015 12.301-4.455s7.238-2.812 10.57-4.028c2.59-.941 5.004-1.82 7.281-2.61 2.276-.79 4.415-1.487 6.447-2.074s3.975-1.05 5.843-1.372 3.688-.51 5.481-.52",
    "data-figma-bg-blur-radius": 1.861
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shield_svg__e)",
    mask: "url(#shield_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.4,
    d: "M165.709 56.629c1.842.063 3.568.3 5.234.681s3.299.925 4.931 1.594c1.633.668 3.293 1.468 5.032 2.368s3.564 1.919 5.54 3.014a217 217 0 0 0 9.05 4.789c3.5 1.742 7.594 3.65 12.234 5.573a221 221 0 0 0 15.993 5.903c6.067 1.981 12.84 3.925 20.382 5.736l3.239.776-.962 2.76c-9.099 26.087-23.314 48.78-39.71 68.008-16.883 19.789-35.629 35.381-53.136 47.296-17.647 12.006-33.746 20.093-45.466 25.171-11.721 5.079-18.975 7.119-19.257 7.2l-2.273.605-1.446-1.248c-.18-.153-4.633-4.123-10.136-11.9-5.352-7.574-11.583-18.596-15.7-32.917s-5.886-30.271-3.33-49.574c2.425-18.34 8.908-39.067 21.576-62.235l1.3-2.377 2.897-.362a219 219 0 0 0 18.73-3.168 209 209 0 0 0 15.431-3.947c4.657-1.379 8.895-2.796 12.819-4.144 3.924-1.347 7.551-2.637 11.024-3.77 2.699-.875 5.215-1.692 7.586-2.423s4.597-1.37 6.708-1.9c2.112-.53 4.126-.932 6.058-1.192s3.809-.38 5.652-.317"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "shield_svg__f",
    width: 185,
    height: 178,
    x: 76,
    y: 57,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    d: "M180.318 57.938c1.794-.01 3.481.15 5.116.452s3.242.76 4.855 1.336 3.258 1.279 4.983 2.074c1.724.796 3.539 1.7 5.503 2.672a213 213 0 0 0 8.983 4.237 192 192 0 0 0 12.11 4.865 218 218 0 0 0 15.776 5.037c5.975 1.663 12.635 3.264 20.037 4.71l3.179.618-.828 2.677c-7.832 25.31-20.769 47.568-35.962 66.593-15.643 19.581-33.261 35.217-49.817 47.287-16.689 12.164-32.025 20.517-43.222 25.825-11.196 5.307-18.169 7.537-18.44 7.625l-2.186.666-1.454-1.139c-.18-.14-4.664-3.768-10.316-10.999-5.497-7.043-11.982-17.351-16.54-30.898-4.558-13.546-6.898-28.74-5.163-47.308 1.645-17.642 7.142-37.722 18.557-60.376l1.172-2.323 2.802-.458a216 216 0 0 0 18.085-3.748 206 206 0 0 0 14.847-4.366c4.474-1.497 8.538-3.015 12.301-4.455s7.238-2.812 10.57-4.028c2.59-.941 5.004-1.82 7.281-2.61 2.276-.79 4.415-1.487 6.447-2.074s3.975-1.05 5.843-1.372 3.688-.51 5.481-.52"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#shield_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DCEFF",
    d: "M183.048 55.77c17.502-16.918-65.23 2.642-67.459 3.37L-9.247 198.17l117.405 51.681c0-39.735 28.432-149.17 74.89-194.08"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#9DCEFF",
    strokeLinejoin: "round",
    strokeWidth: 0.465,
    d: "M158.775 34.978c1.859-.011 3.608.159 5.302.476 1.694.318 3.359.8 5.027 1.405 1.667.606 3.365 1.342 5.142 2.174 1.776.832 3.644 1.779 5.661 2.793h.001a217 217 0 0 0 9.224 4.42c3.563 1.598 7.725 3.34 12.432 5.074a221 221 0 0 0 16.198 5.254c6.136 1.736 12.975 3.406 20.577 4.913l3.268.647a.233.233 0 0 1 .178.296l-.852 2.795c-8.06 26.461-21.372 49.73-37.003 69.616-16.094 20.467-34.219 36.808-51.25 49.422-17.167 12.712-32.943 21.442-44.463 26.989s-18.696 7.88-18.981 7.975l-.004.002-2.247.694a.23.23 0 0 1-.214-.04l-1.495-1.189v-.001c-.215-.17-4.832-3.972-10.643-11.525-5.663-7.372-12.342-18.159-17.037-32.333-4.695-14.175-7.105-30.074-5.318-49.496 1.694-18.455 7.354-39.45 19.098-63.129v-.001l1.205-2.426.03-.046a.23.23 0 0 1 .14-.08l2.88-.477a218 218 0 0 0 18.568-3.91 209 209 0 0 0 15.245-4.554c4.593-1.562 8.767-3.146 12.633-4.649 3.864-1.502 7.441-2.938 10.869-4.209l3.863-1.421q1.868-.684 3.623-1.304a132 132 0 0 1 6.639-2.17c2.095-.615 4.101-1.1 6.031-1.439s3.814-.535 5.673-.547Z"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    width: 189.155,
    height: 181.328,
    x: 52.096,
    y: 35.151
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(.93px)",
      clipPath: "url(#shield_svg__g)",
      height: "100%",
      width: "100%"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DCEFF",
    fillOpacity: 0.2,
    stroke: "#9DCEFF",
    strokeLinejoin: "round",
    strokeWidth: 0.465,
    d: "M158.38 37.245c1.809-.01 3.511.152 5.16.456 1.648.304 3.269.766 4.891 1.346s3.274 1.285 5.002 2.082 3.547 1.703 5.509 2.675l1.984.978a203 203 0 0 0 6.99 3.254 192 192 0 0 0 12.095 4.86 218 218 0 0 0 15.759 5.03c5.969 1.663 12.623 3.262 20.02 4.706l3.178.619a.23.23 0 0 1 .156.108.24.24 0 0 1 .022.189l-.827 2.677h-.001c-7.843 25.342-20.795 47.626-36.002 66.67-15.659 19.6-33.293 35.25-49.862 47.33-16.703 12.173-32.052 20.534-43.259 25.846-11.205 5.312-18.187 7.546-18.467 7.637l-.005.001-2.186.665a.23.23 0 0 1-.211-.039l-1.453-1.138-.269-.22c-1.068-.898-5.132-4.479-10.088-10.82-5.51-7.06-12.009-17.391-16.577-30.967-4.568-13.575-6.913-28.802-5.175-47.403 1.648-17.675 7.155-37.784 18.581-60.46l1.173-2.323.03-.046a.23.23 0 0 1 .14-.08l2.802-.456a215 215 0 0 0 18.064-3.744 206 206 0 0 0 14.831-4.362c4.469-1.495 8.53-3.011 12.291-4.45 3.759-1.44 7.24-2.814 10.574-4.031l3.759-1.361q1.819-.656 3.526-1.25c2.279-.79 4.421-1.489 6.459-2.077 2.038-.59 3.989-1.054 5.867-1.378s3.711-.513 5.519-.524Z",
    "data-figma-bg-blur-radius": 1.861
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "shield_svg__h",
    width: 185,
    height: 178,
    x: 54,
    y: 37,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    d: "M158.382 37.477c1.794-.01 3.481.151 5.115.453 1.635.301 3.243.758 4.856 1.335s3.258 1.28 4.983 2.075 3.539 1.7 5.502 2.671a213 213 0 0 0 8.984 4.237 192 192 0 0 0 12.11 4.865 218 218 0 0 0 15.776 5.037c5.975 1.664 12.635 3.265 20.037 4.71l3.179.618-.828 2.677c-7.832 25.31-20.77 47.568-35.962 66.593-15.644 19.582-33.261 35.218-49.817 47.288-16.689 12.163-32.025 20.517-43.222 25.824-11.196 5.307-18.17 7.537-18.44 7.626l-2.186.665-1.454-1.138c-.18-.141-4.664-3.769-10.316-11-5.497-7.043-11.982-17.351-16.54-30.897-4.558-13.547-6.898-28.741-5.163-47.308 1.645-17.643 7.142-37.723 18.556-60.377l1.173-2.323 2.802-.457a216 216 0 0 0 18.085-3.748 206 206 0 0 0 14.847-4.367c4.473-1.497 8.538-3.015 12.3-4.455s7.239-2.812 10.571-4.028c2.59-.941 5.004-1.82 7.281-2.61 2.276-.79 4.414-1.486 6.447-2.074 2.032-.587 3.974-1.05 5.842-1.372s3.688-.51 5.482-.52"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#shield_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M161.112 35.31c17.502-16.92-65.23 2.642-67.46 3.37L-31.182 177.707l117.405 51.681c0-39.735 28.432-149.17 74.89-194.08"
  })))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DCEFF",
    fillOpacity: 0.5,
    fillRule: "evenodd",
    d: "M158.776 35.21a27.5 27.5 0 0 1 5.258.473c1.68.314 3.333.792 4.991 1.394 1.658.603 3.348 1.336 5.121 2.166s3.638 1.775 5.656 2.79a217 217 0 0 0 9.235 4.424 195 195 0 0 0 12.447 5.081 221 221 0 0 0 16.215 5.26c6.141 1.737 12.987 3.409 20.595 4.918l3.268.645-.852 2.796c-8.05 26.43-21.348 49.673-36.963 69.539-16.08 20.448-34.188 36.776-51.206 49.38-17.153 12.702-32.916 21.425-44.424 26.967s-18.676 7.871-18.954 7.963l-2.248.694-1.494-1.188c-.185-.147-4.794-3.936-10.603-11.487-5.65-7.355-12.316-18.119-17.001-32.264s-7.09-30.012-5.307-49.401c1.691-18.423 7.341-39.392 19.074-63.047l1.204-2.426 2.88-.478a219 219 0 0 0 18.59-3.914 209 209 0 0 0 15.26-4.56c4.598-1.563 8.776-3.148 12.644-4.652 3.867-1.503 7.44-2.936 10.865-4.206 2.661-.982 5.143-1.9 7.482-2.725s4.538-1.552 6.627-2.165c2.089-.614 4.086-1.097 6.006-1.434s3.79-.532 5.634-.543m-.394 2.267c-1.793.01-3.613.199-5.481.521s-3.811.785-5.843 1.372a129 129 0 0 0-6.447 2.074c-2.277.79-4.691 1.669-7.28 2.61-3.333 1.216-6.809 2.588-10.572 4.028s-7.826 2.958-12.3 4.455a206 206 0 0 1-14.847 4.366 216 216 0 0 1-18.085 3.748l-2.802.457-1.173 2.324c-11.414 22.653-16.911 42.734-18.556 60.377-1.736 18.567.604 33.761 5.163 47.307 4.558 13.547 11.043 23.854 16.54 30.898 5.65 7.228 10.133 10.856 10.316 10.999l1.454 1.138 2.187-.665c.275-.089 7.246-2.32 18.439-7.626 11.197-5.307 26.533-13.66 43.222-25.824 16.556-12.07 34.174-27.706 49.817-47.287 15.193-19.025 28.13-41.283 35.962-66.593l.828-2.678-3.178-.618c-7.403-1.445-14.063-3.046-20.039-4.71a218 218 0 0 1-15.775-5.037 192 192 0 0 1-12.109-4.865 213 213 0 0 1-8.985-4.236c-1.963-.972-3.778-1.877-5.503-2.672-1.724-.795-3.369-1.497-4.982-2.074s-3.221-1.035-4.855-1.336a27 27 0 0 0-5.116-.453",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "shield_svg__i",
    width: 185,
    height: 178,
    x: 54,
    y: 37,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    d: "M158.382 37.477a27 27 0 0 1 5.115.453c1.635.301 3.243.758 4.856 1.335s3.258 1.28 4.983 2.075 3.539 1.7 5.502 2.671a213 213 0 0 0 8.984 4.237 192 192 0 0 0 12.11 4.865 218 218 0 0 0 15.776 5.037c5.975 1.664 12.635 3.265 20.037 4.71l3.179.618-.828 2.677c-7.832 25.31-20.77 47.568-35.962 66.593-15.644 19.582-33.261 35.218-49.817 47.288-16.689 12.163-32.025 20.517-43.222 25.824-11.196 5.307-18.17 7.537-18.44 7.626l-2.186.665-1.454-1.138c-.18-.141-4.664-3.769-10.316-11-5.497-7.043-11.982-17.351-16.54-30.897-4.558-13.547-6.899-28.741-5.163-47.308 1.645-17.643 7.142-37.723 18.556-60.377l1.173-2.323 2.802-.457a216 216 0 0 0 18.085-3.748 206 206 0 0 0 14.847-4.367c4.473-1.497 8.538-3.015 12.3-4.455s7.239-2.812 10.571-4.028c2.59-.941 5.004-1.82 7.28-2.61a129 129 0 0 1 6.448-2.074c2.032-.587 3.974-1.05 5.842-1.372s3.688-.51 5.482-.52"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#shield_svg__i)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M161.112 35.31c17.502-16.92-65.23 2.642-67.46 3.37L-31.182 177.707l117.405 51.681c0-39.735 28.432-149.17 74.89-194.08"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "shield_svg__j",
    width: 171,
    height: 172,
    x: 99,
    y: 83,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    d: "m263.467 83.432 5.631 17.787c-7.473 25.704-19.582 49.704-35.931 70.979-14.887 19.374-32.603 35.758-48.867 47.948-16.389 12.282-31.485 20.674-42.514 25.994-6.701 3.232-13.484 6.182-20.57 8.349-8.862-7.048-14.976-16.43-21.976-25.216l.49-.39.1.128c3.149 3.944 6.563 7.65 10.502 10.798l2.062-.641.006-.001.015-.005c.503-.167 7.565-2.506 18.722-7.907 11.362-5.5 26.99-14.18 43.969-26.818 16.843-12.536 34.765-28.773 50.677-49.106 17.089-21.833 29.67-45.442 37.684-71.9"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#shield_svg__j)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m269.098 72.815 21.808 40.435-50.065 49.618-21.122-41.743z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0863BF",
    d: "m143.991 182.267 34.859 56.008-63.117 34.045-21.121-41.743z"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#6965D2",
    stroke: "#111",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.414,
    d: "m84.61 259.229-5.1-14.247 1.87-2.375 5.101 14.247z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#B085F8",
    stroke: "#111",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.414,
    d: "m84.611 259.228-2.759-.829-5.1-14.247 2.758.829z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#ABABAB",
    stroke: "#111",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.414,
    d: "m79.51 244.982-2.758-.829 1.87-2.374 2.759.829z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#B085F8",
    stroke: "#111",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.414,
    d: "m82.49 251.294-13.149-38.139 7.789-9.241 12.955 38.036z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#6965D2",
    stroke: "#111",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.414,
    d: "m82.49 251.294-11.069-3.618-12.893-38.078 11.049 3.546z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#3E26C5",
    stroke: "#111",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.414,
    d: "m69.56 213.253-11.068-3.613 7.6-9.347 11.064 3.62z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#6965D2",
    stroke: "#111",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.414,
    d: "m68.168 208.584-5.636-14.795 1.866-2.373 5.636 14.796z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#B085F8",
    stroke: "#111",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.414,
    d: "m68.168 208.585-2.761-.834-5.64-14.794 2.765.832z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#3E26C5",
    stroke: "#111",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.414,
    d: "m62.532 193.789-2.765-.832 1.87-2.375 2.76.834z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#79E90A",
    stroke: "#111",
    strokeMiterlimit: 10,
    strokeWidth: 0.414,
    d: "m72.854 275.568-10.56-16.798 1.293-2.55 10.56 16.798z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#CEFF9D",
    stroke: "#111",
    strokeMiterlimit: 10,
    strokeWidth: 0.414,
    d: "m72.854 275.568-2.715-.261-10.56-16.798 2.715.261z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#ABABAB",
    stroke: "#111",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.414,
    d: "m62.294 258.77-2.715-.262 1.293-2.55 2.715.262z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#CEFF9D",
    stroke: "#111",
    strokeMiterlimit: 10,
    strokeWidth: 0.414,
    d: "m66.22 264.072-33.417-57.529 5.325-10.073 33.417 57.529z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#79E90A",
    stroke: "#111",
    strokeMiterlimit: 10,
    strokeWidth: 0.414,
    d: "m66.22 264.074-10.94-1.313-33.416-57.53 10.939 1.314z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7FFCE",
    stroke: "#111",
    strokeMiterlimit: 10,
    strokeWidth: 0.414,
    d: "m32.803 206.545-10.94-1.313 5.326-10.074 10.939 1.314z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#79E90A",
    stroke: "#111",
    strokeMiterlimit: 10,
    strokeWidth: 0.414,
    d: "m30.271 202.733-15.12-24.054 1.299-2.55 15.119 24.054z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#CEF883",
    stroke: "#111",
    strokeMiterlimit: 10,
    strokeWidth: 0.414,
    d: "m30.27 202.732-2.714-.262-15.12-24.053 2.715.261z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7FFCE",
    stroke: "#111",
    strokeMiterlimit: 10,
    strokeWidth: 0.414,
    d: "m15.152 178.678-2.715-.261 1.297-2.55 2.715.261z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#242424",
    d: "M169.412 130.592c.995-2.733 3.966-4.846 6.635-4.721l112.791.76c2.67.126 5.035 3.922 4.04 6.655l-8.675 22.935c-.994 2.732-3.985 6.067-6.654 5.942l-113.486-5.942c-2.67-.126-3.966-4.397-2.971-7.13z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 132.512,
    height: 33.086,
    fill: "#E7F3FF",
    rx: 5.265,
    transform: "matrix(.91808 .04316 -.34202 .9397 170.5 120.757)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m268.633 143.42-3.545 2.985-1.692-1.688 3.57-2.803-3.344-1.14 1.894-2.437 3.117 1.461 1.504-3.726 2.897.151-1.536 3.724 4.143-1.082-.111 2.53-4.139.75 1.207 3.051-2.925 1.448zM252.606 142.584l-3.545 2.985-1.692-1.688 3.57-2.803-3.344-1.14 1.894-2.437 3.117 1.461 1.504-3.726 2.897.152-1.535 3.723 4.143-1.082-.112 2.53-4.139.75 1.207 3.051-2.925 1.448zM236.579 141.749l-3.545 2.985-1.692-1.688 3.57-2.803-3.344-1.14 1.894-2.437 3.117 1.46 1.504-3.725 2.897.151-1.535 3.724 4.143-1.082-.112 2.53-4.139.75 1.207 3.051-2.925 1.448zM220.553 140.913l-3.546 2.985-1.692-1.688 3.57-2.803-3.343-1.14 1.894-2.437 3.116 1.461 1.504-3.725 2.898.151-1.536 3.723 4.143-1.082-.111 2.53-4.139.75 1.206 3.052-2.925 1.447zM204.526 140.077l-3.546 2.985-1.692-1.688 3.57-2.802-3.343-1.141 1.894-2.437 3.116 1.461 1.504-3.725 2.898.151-1.536 3.723 4.143-1.082-.111 2.53-4.139.75 1.206 3.052-2.925 1.447z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDFF00",
    d: "M182.392 136.561c4.543.448 7.069 4.485 5.635 9.019l-.537 1.706c-.184.58-.797 1.003-1.382.946l-15.617-1.535c-.58-.058-.905-.571-.721-1.15l.537-1.706c1.429-4.533 6.271-7.85 10.825-7.403zM185.16 125.73c2.66.261 4.143 2.619 3.305 5.278s-3.672 4.595-6.337 4.335-4.134-2.627-3.3-5.28c.833-2.653 3.667-4.588 6.333-4.328z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M187.372 139.758c-1.016-1.035-2.442-1.726-4.157-1.9l-1.256-.119c-4.502-.444-9.297 2.84-10.715 7.33l-.465 1.471-.399-.036a.73.73 0 0 1-.567-.325.81.81 0 0 1-.067-.685l.539-1.702c1.418-4.49 6.214-7.774 10.715-7.331l1.256.12c2.24.224 3.981 1.329 4.984 2.932q.076.115.132.245M188.151 127.899c-.531-.448-1.225-.75-2.027-.851l-.141-.017c-2.609-.251-5.398 1.651-6.216 4.253-.344 1.101-.283 2.157.098 3.009a3.4 3.4 0 0 1-.733-.832c-.575-.926-.733-2.153-.324-3.454.818-2.603 3.608-4.504 6.216-4.254l.141.018c1.233.153 2.189.778 2.744 1.671q.135.215.242.457"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.143,
    d: "M170.376 143.863c1.375-4.362 5.933-7.59 10.324-7.385l.425.031 1.26.123c2.251.222 3.997 1.333 5.005 2.944 1.008 1.613 1.281 3.733.569 5.983h-.001l-.537 1.706c-.174.549-.757.949-1.305.896l-15.618-1.535a.77.77 0 0 1-.593-.347c-.118-.188-.153-.438-.067-.71h.001zM178.896 130.085c.824-2.623 3.628-4.536 6.258-4.279l.094.009-.001-.003c1.264.15 2.245.784 2.817 1.696.586.935.747 2.167.333 3.479-.828 2.629-3.632 4.541-6.262 4.284-1.312-.128-2.325-.773-2.909-1.708-.584-.936-.742-2.169-.33-3.478Z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shield_svg__k)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DCEFF",
    d: "M13.098 50.417c-6.646 5.952 2.155 23.909 18.15 40.82 15.995 16.91 34.31 23.638 39.707 18.825 7.55-6.734-1.128-22.994-16.734-39.08-17.955-18.504-34.402-26.585-41.123-20.565"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    stroke: "#054280",
    strokeWidth: 0.167,
    d: "M19.827 48.571c-2.751-.199-5.015.423-6.673 1.909-1.637 1.465-2.33 3.675-2.19 6.444s1.113 6.09 2.795 9.759c3.364 7.336 9.557 16.045 17.55 24.496 7.99 8.448 16.56 14.351 23.8 17.54 3.621 1.594 6.907 2.509 9.62 2.726 2.717.218 4.846-.264 6.17-1.445 3.73-3.326 3.471-9.023.297-15.936C68.025 87.158 61.96 79.08 54.16 71.04c-8.973-9.249-17.566-15.888-24.75-19.463-3.593-1.788-6.83-2.808-9.583-3.007Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#054280",
    d: "M19.835 52.906c-4.718 3.924 3.846 18.016 17.291 32.23 13.445 14.216 28.314 21.449 31.925 18.033 4.244-4.014-2.578-17.619-16.023-31.834C41.036 58.657 24.354 49.15 19.835 52.906"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    d: "M19.444 53.674c-4.338 3.568 4.34 17.353 17.665 31.44s27.738 21.56 31.042 18.435c3.883-3.673-3.12-16.926-16.444-31.014-11.885-12.565-28.11-22.279-32.263-18.861"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m24.309 66.723 13.66-5.364 7.468 8.656-13.79 5.415z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m36.9 76.117 11.449 11.52 7.625-2.994-5.943-6.502-4.544 1.785-5.046-5.2z",
    clipRule: "evenodd"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m52.055 88.866 12.172 11.428-8.992-12.677z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shield_svg__l)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DCEFF",
    d: "M254.299 196.526c13.702 14.52 7.333 38.161-11.076 54.689-18.41 16.527-45.506 15.288-56.327 3.234-12.72-14.168-8.734-36.965 9.675-53.493 16.421-14.742 44.605-18.337 57.728-4.43"
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    stroke: "#054280",
    strokeWidth: 0.162,
    d: "M226.679 188.078c10.724-1.002 21.022 1.574 27.561 8.504 6.829 7.237 8.66 16.748 6.484 26.518-2.176 9.771-8.36 19.799-17.555 28.054-9.19 8.25-20.547 12.067-30.957 12.315-10.413.249-19.866-3.07-25.256-9.074-12.678-14.121-8.722-36.867 9.669-53.379 8.197-7.358 19.332-11.937 30.054-12.938Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    fillRule: "evenodd",
    d: "M200.221 204.295c14.075-12.636 37.578-16.448 48.051-5.391 10.908 11.516 4.961 31.11-10.736 45.269-12.514 11.166-29.234 13.356-40.252 9.076-2.684-1.13-4.978-2.678-6.71-4.608-10.13-11.284-6.133-30.179 9.647-44.346",
    clipRule: "evenodd"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#054280",
    fillRule: "evenodd",
    d: "M198.94 202.446c14.344-12.877 38.48-16.554 49.372-5.043 11.373 12.02 5.412 32.226-10.669 46.663l-.05.043c15.657-14.156 21.579-33.719 10.682-45.223-10.473-11.056-33.975-7.243-48.05 5.393-15.78 14.167-19.777 33.061-9.647 44.345 1.729 1.925 4.015 3.472 6.692 4.601-3.129-1.218-5.797-2.957-7.776-5.162-10.542-11.742-6.635-31.18 9.446-45.617",
    clipRule: "evenodd"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m215.435 205.687 35.025 1.076-10.206 8.141-35.355-1.086z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m211.403 216.022-11.214 11.34 19.553.601 7.141-6.227-11.652-.357 5.252-5.078z",
    clipRule: "evenodd"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m202.893 229.403-9.843 11.522 17.998-11.271z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "shield_svg__b",
    transform: "translate(-74.031 -55.61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.316 57.705c1.809-.01 3.511.152 5.16.456 1.648.304 3.269.765 4.891 1.346 1.622.58 3.274 1.285 5.002 2.082s3.547 1.703 5.509 2.675l1.984.978a202 202 0 0 0 6.991 3.254 192 192 0 0 0 12.094 4.86c4.58 1.66 9.87 3.39 15.759 5.03 5.969 1.662 12.623 3.262 20.02 4.706l3.178.619a.23.23 0 0 1 .156.108.24.24 0 0 1 .022.189l-.827 2.677h-.001c-7.842 25.342-20.795 47.626-36.002 66.669-15.659 19.601-33.293 35.251-49.862 47.331-16.703 12.173-32.052 20.534-43.259 25.846-11.205 5.312-18.187 7.545-18.467 7.637l-.005.001-2.186.665a.23.23 0 0 1-.211-.039l-1.453-1.138-.269-.22c-1.068-.898-5.132-4.479-10.088-10.82-5.51-7.06-12.009-17.391-16.577-30.967-4.568-13.575-6.913-28.802-5.175-47.403 1.648-17.675 7.156-37.784 18.581-60.46l1.173-2.323.03-.046a.23.23 0 0 1 .14-.08l2.802-.456a215 215 0 0 0 18.064-3.744 206 206 0 0 0 14.831-4.362c4.469-1.495 8.53-3.011 12.291-4.45 3.759-1.44 7.24-2.814 10.575-4.031l3.758-1.361q1.818-.656 3.526-1.25c2.279-.79 4.421-1.489 6.459-2.078 2.039-.589 3.989-1.053 5.867-1.378s3.711-.512 5.519-.523"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "shield_svg__c",
    transform: "translate(-74.031 -55.61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.318 57.938c1.794-.01 3.481.15 5.116.452s3.242.76 4.855 1.336 3.258 1.279 4.983 2.074c1.724.796 3.539 1.7 5.503 2.672a213 213 0 0 0 8.983 4.237 192 192 0 0 0 12.11 4.865 218 218 0 0 0 15.776 5.037c5.975 1.663 12.635 3.264 20.037 4.71l3.179.618-.828 2.677c-7.832 25.31-20.769 47.568-35.962 66.593-15.643 19.581-33.261 35.217-49.817 47.287-16.689 12.164-32.025 20.517-43.222 25.825-11.196 5.307-18.169 7.537-18.44 7.625l-2.186.666-1.454-1.139c-.18-.14-4.664-3.768-10.316-10.999-5.497-7.043-11.982-17.351-16.54-30.898-4.558-13.546-6.898-28.74-5.163-47.308 1.645-17.642 7.142-37.722 18.557-60.376l1.172-2.323 2.802-.458a216 216 0 0 0 18.085-3.748 206 206 0 0 0 14.847-4.366c4.474-1.497 8.538-3.015 12.301-4.455s7.238-2.812 10.57-4.028c2.59-.941 5.004-1.82 7.281-2.61 2.276-.79 4.415-1.487 6.447-2.074s3.975-1.05 5.843-1.372 3.688-.51 5.481-.52"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "shield_svg__g",
    transform: "translate(-52.096 -35.15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.38 37.245c1.809-.01 3.511.152 5.16.456 1.648.304 3.269.766 4.891 1.346s3.274 1.285 5.002 2.082 3.547 1.703 5.509 2.675l1.984.978a203 203 0 0 0 6.99 3.254 192 192 0 0 0 12.095 4.86 218 218 0 0 0 15.759 5.03c5.969 1.663 12.623 3.262 20.02 4.706l3.178.619a.23.23 0 0 1 .156.108.24.24 0 0 1 .022.189l-.827 2.677h-.001c-7.843 25.342-20.795 47.626-36.002 66.67-15.659 19.6-33.293 35.25-49.862 47.33-16.703 12.173-32.052 20.534-43.259 25.846-11.205 5.312-18.187 7.546-18.467 7.637l-.005.001-2.186.665a.23.23 0 0 1-.211-.039l-1.453-1.138-.269-.22c-1.068-.898-5.132-4.479-10.088-10.82-5.51-7.06-12.009-17.391-16.577-30.967-4.568-13.575-6.913-28.802-5.175-47.403 1.648-17.675 7.155-37.784 18.581-60.46l1.173-2.323.03-.046a.23.23 0 0 1 .14-.08l2.802-.456a215 215 0 0 0 18.064-3.744 206 206 0 0 0 14.831-4.362c4.469-1.495 8.53-3.011 12.291-4.45 3.759-1.44 7.24-2.814 10.574-4.031l3.759-1.361q1.819-.656 3.526-1.25c2.279-.79 4.421-1.489 6.459-2.077 2.038-.59 3.989-1.054 5.867-1.378s3.711-.513 5.519-.524"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "shield_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h300v300H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shield_svg__e",
    width: 197.312,
    height: 186.196,
    x: 52.385,
    y: 54.26,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_12143_11744",
    stdDeviation: 1.176
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shield_svg__k",
    width: 63.524,
    height: 63.795,
    x: 10.196,
    y: 47.784,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.504,
    dy: -3.672
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.334
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.513726 0 0 0 0 0.756863 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_12143_11744"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shield_svg__l",
    width: 82.817,
    height: 76.421,
    x: 178.855,
    y: 187.143,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.616,
    dy: -2.424
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.323
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.513726 0 0 0 0 0.756863 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_12143_11744"
  })))));
};
export default SvgShield;